﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconList } from "@tabler/icons-react";
import { ListasValoresDef } from "./ListasValoresDef";

export const ListasValoresIcon = IconList;
export const ListasValoresHelpText = '* Aquí puede ver y dar de alta las listas de valores';

export class ListasValores extends Entity<ListasValoresDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ListasValoresDef(), parentKeys);
        super.Form = import('./ListasValoresForm').then((module) => module.ListasValoresForm);
        this.Title = "Listas de Valores";
        this.HelpText = ListasValoresHelpText;
        this.Icon = ListasValoresIcon;
    }
}